/**
 * Roteamento simples baseado em window.location.pathname.
 * Padroes:
 *   /            -> modo principal (admin)
 *   /{slug}      -> modo replica (filtra pela empresa configurada)
 *
 * O slug e o nome literal que o user pos como chave em replicas.config.js.
 * Ex: /bhaz, /etus, /replica1.
 *
 * Uso: import getReplicaSlug + onPathChange. Pra navegar use navigate().
 */

const REPLICA_RE = /^\/([a-z0-9_-]+)\/?$/i;

export function getReplicaSlug() {
  const path = typeof window !== 'undefined' ? window.location.pathname : '/';
  const m = path.match(REPLICA_RE);
  return m ? m[1].toLowerCase() : null;
}

export function navigate(path) {
  if (typeof window === 'undefined') return;
  if (window.location.pathname === path) return;
  window.history.pushState({}, '', path);
  // Dispara evento sintetico pra hooks reagirem (popstate so dispara em
  // navegacao back/forward; pushState nao dispara nativamente)
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function onPathChange(callback) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener('popstate', callback);
  return () => window.removeEventListener('popstate', callback);
}
